export const IMMIGRATE_QUESTION_REMOVE_REQUEST = 'immigrate-question/remove-request'
export const IMMIGRATE_QUESTION_REMOVE_SUCCESS = 'immigrate-question/remove-success'
export const IMMIGRATE_QUESTION_REMOVE_FAILED = 'immigrate-question/remove-failed'
